unit View.Plano_Contas.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewPlano_ContasList = class(TForm)
    btNew: TButton;
    Plano_ContasDataset: TXDataWebDataSet;
    Plano_ContasDatasetid: TIntegerField;
    Plano_ContasDatasetaliado_id: TIntegerField;
    Plano_ContasDatasetdata_base_id: TIntegerField;
    Plano_ContasDatasetplano_contas1_id: TIntegerField;
    Plano_ContasDatasetplano_contas2_id: TIntegerField;
    Plano_ContasDatasetplano_contas3_id: TIntegerField;
    Plano_ContasDatasetplano_contas_contabil_id: TIntegerField;
    Plano_ContasDatasetnome: TStringField;
    Plano_ContasDatasetclasse: TIntegerField;
    Plano_ContasDatasetpeso_ideal: TFloatField;
    Plano_ContasDatasetaparece_dre: TBooleanField;
    Plano_ContasDatasetdebito_credito: TIntegerField;
    Plano_ContasDatasetdeducao_adicao: TIntegerField;
    Plano_ContasDatasetdespesas: TBooleanField;
    Plano_ContasDatasetinvestimentos: TBooleanField;
    Plano_ContasDatasetbalanco_patrimonial: TBooleanField;
    Plano_ContasDatasetdemonstrativo_financeiro: TBooleanField;
    Plano_ContasDatasetcodigo_interno: TIntegerField;
    Plano_ContasDatasetexcluido: TBooleanField;
    Plano_ContasDatasetinclusao: TDateTimeField;
    Plano_ContasDatasetalteracao: TDateTimeField;
    Plano_ContasDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewPlano_ContasList: TFViewPlano_ContasList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewPlano_ContasList }

procedure TFViewPlano_ContasList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewPlano_ContasList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewPlano_ContasList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewPlano_ContasList, AElementID, Result, @AfterCreate);
end;

procedure TFViewPlano_ContasList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewPlano_ContasList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewPlano_ContasList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Plano_ContasDataset.Connection.Model.DefaultSchema.FindEntityType(Plano_ContasDataset.EntitySetName),
      Plano_ContasDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewPlano_ContasList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('plano_contas', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetValorDicionarioClasses('plano_contas_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_plano_contas', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Plano_ContasDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewPlano_ContasList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.plano_contas.list.pagination.info');
  btNew := TButton.Create('view.plano_contas.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.plano_contas.list.table');
  cbPageSize := TComboBox.Create('view.plano_contas.list.cbPageSize');
  edSearch := TEdit.Create('view.plano_contas.list.search');
  lcPaginator := TListControl.Create('view.plano_contas.list.pagination');
  Plano_ContasDataset := TXDataWebDataSet.Create(Self);
  Plano_ContasDatasetid := TIntegerField.Create(Self);
  Plano_ContasDatasetaliado_id := TIntegerField.Create(Self);
  Plano_ContasDatasetdata_base_id := TIntegerField.Create(Self);
  Plano_ContasDatasetplano_contas1_id := TIntegerField.Create(Self);
  Plano_ContasDatasetplano_contas2_id := TIntegerField.Create(Self);
  Plano_ContasDatasetplano_contas3_id := TIntegerField.Create(Self);
  Plano_ContasDatasetplano_contas_contabil_id := TIntegerField.Create(Self);
  Plano_ContasDatasetnome := TStringField.Create(Self);
  Plano_ContasDatasetclasse := TIntegerField.Create(Self);
  Plano_ContasDatasetpeso_ideal := TFloatField.Create(Self);
  Plano_ContasDatasetaparece_dre := TBooleanField.Create(Self);
  Plano_ContasDatasetdebito_credito := TIntegerField.Create(Self);
  Plano_ContasDatasetdeducao_adicao := TIntegerField.Create(Self);
  Plano_ContasDatasetdespesas := TBooleanField.Create(Self);
  Plano_ContasDatasetinvestimentos := TBooleanField.Create(Self);
  Plano_ContasDatasetbalanco_patrimonial := TBooleanField.Create(Self);
  Plano_ContasDatasetdemonstrativo_financeiro := TBooleanField.Create(Self);
  Plano_ContasDatasetcodigo_interno := TIntegerField.Create(Self);
  Plano_ContasDatasetexcluido := TBooleanField.Create(Self);
  Plano_ContasDatasetinclusao := TDateTimeField.Create(Self);
  Plano_ContasDatasetalteracao := TDateTimeField.Create(Self);
  Plano_ContasDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Plano_ContasDataset.BeforeLoadDFMValues;
  Plano_ContasDatasetid.BeforeLoadDFMValues;
  Plano_ContasDatasetaliado_id.BeforeLoadDFMValues;
  Plano_ContasDatasetdata_base_id.BeforeLoadDFMValues;
  Plano_ContasDatasetplano_contas1_id.BeforeLoadDFMValues;
  Plano_ContasDatasetplano_contas2_id.BeforeLoadDFMValues;
  Plano_ContasDatasetplano_contas3_id.BeforeLoadDFMValues;
  Plano_ContasDatasetplano_contas_contabil_id.BeforeLoadDFMValues;
  Plano_ContasDatasetnome.BeforeLoadDFMValues;
  Plano_ContasDatasetclasse.BeforeLoadDFMValues;
  Plano_ContasDatasetpeso_ideal.BeforeLoadDFMValues;
  Plano_ContasDatasetaparece_dre.BeforeLoadDFMValues;
  Plano_ContasDatasetdebito_credito.BeforeLoadDFMValues;
  Plano_ContasDatasetdeducao_adicao.BeforeLoadDFMValues;
  Plano_ContasDatasetdespesas.BeforeLoadDFMValues;
  Plano_ContasDatasetinvestimentos.BeforeLoadDFMValues;
  Plano_ContasDatasetbalanco_patrimonial.BeforeLoadDFMValues;
  Plano_ContasDatasetdemonstrativo_financeiro.BeforeLoadDFMValues;
  Plano_ContasDatasetcodigo_interno.BeforeLoadDFMValues;
  Plano_ContasDatasetexcluido.BeforeLoadDFMValues;
  Plano_ContasDatasetinclusao.BeforeLoadDFMValues;
  Plano_ContasDatasetalteracao.BeforeLoadDFMValues;
  Plano_ContasDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewPlano_ContasList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'plano_contas1_id';
      Title := 'plano_contas1_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'plano_contas2_id';
      Title := 'plano_contas2_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'plano_contas3_id';
      Title := 'plano_contas3_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'plano_contas_contabil_id';
      Title := 'plano_contas_contabil_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'classe';
      Title := 'classe';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'peso_ideal';
      Title := 'peso_ideal';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aparece_dre';
      Title := 'aparece_dre';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'debito_credito';
      Title := 'debito_credito';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'deducao_adicao';
      Title := 'deducao_adicao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'despesas';
      Title := 'despesas';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'investimentos';
      Title := 'investimentos';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'balanco_patrimonial';
      Title := 'balanco_patrimonial';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'demonstrativo_financeiro';
      Title := 'demonstrativo_financeiro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Plano_ContasDataset.SetParentComponent(Self);
    Plano_ContasDataset.Name := 'Plano_ContasDataset';
    Plano_ContasDataset.EntitySetName := 'Plano_Contas';
    Plano_ContasDataset.Connection := DMConnection.ApiConnection;
    Plano_ContasDataset.Left := 72;
    Plano_ContasDataset.Top := 144;
    Plano_ContasDatasetid.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetid.Name := 'Plano_ContasDatasetid';
    Plano_ContasDatasetid.FieldName := 'id';
    Plano_ContasDatasetid.Required := True;
    Plano_ContasDatasetaliado_id.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetaliado_id.Name := 'Plano_ContasDatasetaliado_id';
    Plano_ContasDatasetaliado_id.FieldName := 'aliado_id';
    Plano_ContasDatasetaliado_id.Required := True;
    Plano_ContasDatasetdata_base_id.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetdata_base_id.Name := 'Plano_ContasDatasetdata_base_id';
    Plano_ContasDatasetdata_base_id.FieldName := 'data_base_id';
    Plano_ContasDatasetdata_base_id.Required := True;
    Plano_ContasDatasetplano_contas1_id.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetplano_contas1_id.Name := 'Plano_ContasDatasetplano_contas1_id';
    Plano_ContasDatasetplano_contas1_id.FieldName := 'plano_contas1_id';
    Plano_ContasDatasetplano_contas2_id.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetplano_contas2_id.Name := 'Plano_ContasDatasetplano_contas2_id';
    Plano_ContasDatasetplano_contas2_id.FieldName := 'plano_contas2_id';
    Plano_ContasDatasetplano_contas3_id.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetplano_contas3_id.Name := 'Plano_ContasDatasetplano_contas3_id';
    Plano_ContasDatasetplano_contas3_id.FieldName := 'plano_contas3_id';
    Plano_ContasDatasetplano_contas_contabil_id.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetplano_contas_contabil_id.Name := 'Plano_ContasDatasetplano_contas_contabil_id';
    Plano_ContasDatasetplano_contas_contabil_id.FieldName := 'plano_contas_contabil_id';
    Plano_ContasDatasetnome.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetnome.Name := 'Plano_ContasDatasetnome';
    Plano_ContasDatasetnome.FieldName := 'nome';
    Plano_ContasDatasetnome.Required := True;
    Plano_ContasDatasetnome.Size := 255;
    Plano_ContasDatasetclasse.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetclasse.Name := 'Plano_ContasDatasetclasse';
    Plano_ContasDatasetclasse.FieldName := 'classe';
    Plano_ContasDatasetpeso_ideal.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetpeso_ideal.Name := 'Plano_ContasDatasetpeso_ideal';
    Plano_ContasDatasetpeso_ideal.FieldName := 'peso_ideal';
    Plano_ContasDatasetaparece_dre.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetaparece_dre.Name := 'Plano_ContasDatasetaparece_dre';
    Plano_ContasDatasetaparece_dre.FieldName := 'aparece_dre';
    Plano_ContasDatasetdebito_credito.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetdebito_credito.Name := 'Plano_ContasDatasetdebito_credito';
    Plano_ContasDatasetdebito_credito.FieldName := 'debito_credito';
    Plano_ContasDatasetdeducao_adicao.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetdeducao_adicao.Name := 'Plano_ContasDatasetdeducao_adicao';
    Plano_ContasDatasetdeducao_adicao.FieldName := 'deducao_adicao';
    Plano_ContasDatasetdespesas.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetdespesas.Name := 'Plano_ContasDatasetdespesas';
    Plano_ContasDatasetdespesas.FieldName := 'despesas';
    Plano_ContasDatasetdespesas.Required := True;
    Plano_ContasDatasetinvestimentos.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetinvestimentos.Name := 'Plano_ContasDatasetinvestimentos';
    Plano_ContasDatasetinvestimentos.FieldName := 'investimentos';
    Plano_ContasDatasetinvestimentos.Required := True;
    Plano_ContasDatasetbalanco_patrimonial.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetbalanco_patrimonial.Name := 'Plano_ContasDatasetbalanco_patrimonial';
    Plano_ContasDatasetbalanco_patrimonial.FieldName := 'balanco_patrimonial';
    Plano_ContasDatasetbalanco_patrimonial.Required := True;
    Plano_ContasDatasetdemonstrativo_financeiro.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetdemonstrativo_financeiro.Name := 'Plano_ContasDatasetdemonstrativo_financeiro';
    Plano_ContasDatasetdemonstrativo_financeiro.FieldName := 'demonstrativo_financeiro';
    Plano_ContasDatasetdemonstrativo_financeiro.Required := True;
    Plano_ContasDatasetcodigo_interno.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetcodigo_interno.Name := 'Plano_ContasDatasetcodigo_interno';
    Plano_ContasDatasetcodigo_interno.FieldName := 'codigo_interno';
    Plano_ContasDatasetcodigo_interno.Required := True;
    Plano_ContasDatasetexcluido.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetexcluido.Name := 'Plano_ContasDatasetexcluido';
    Plano_ContasDatasetexcluido.FieldName := 'excluido';
    Plano_ContasDatasetinclusao.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetinclusao.Name := 'Plano_ContasDatasetinclusao';
    Plano_ContasDatasetinclusao.FieldName := 'inclusao';
    Plano_ContasDatasetalteracao.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetalteracao.Name := 'Plano_ContasDatasetalteracao';
    Plano_ContasDatasetalteracao.FieldName := 'alteracao';
    Plano_ContasDatasetexclusao.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetexclusao.Name := 'Plano_ContasDatasetexclusao';
    Plano_ContasDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Plano_ContasDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Plano_ContasDataset.AfterLoadDFMValues;
    Plano_ContasDatasetid.AfterLoadDFMValues;
    Plano_ContasDatasetaliado_id.AfterLoadDFMValues;
    Plano_ContasDatasetdata_base_id.AfterLoadDFMValues;
    Plano_ContasDatasetplano_contas1_id.AfterLoadDFMValues;
    Plano_ContasDatasetplano_contas2_id.AfterLoadDFMValues;
    Plano_ContasDatasetplano_contas3_id.AfterLoadDFMValues;
    Plano_ContasDatasetplano_contas_contabil_id.AfterLoadDFMValues;
    Plano_ContasDatasetnome.AfterLoadDFMValues;
    Plano_ContasDatasetclasse.AfterLoadDFMValues;
    Plano_ContasDatasetpeso_ideal.AfterLoadDFMValues;
    Plano_ContasDatasetaparece_dre.AfterLoadDFMValues;
    Plano_ContasDatasetdebito_credito.AfterLoadDFMValues;
    Plano_ContasDatasetdeducao_adicao.AfterLoadDFMValues;
    Plano_ContasDatasetdespesas.AfterLoadDFMValues;
    Plano_ContasDatasetinvestimentos.AfterLoadDFMValues;
    Plano_ContasDatasetbalanco_patrimonial.AfterLoadDFMValues;
    Plano_ContasDatasetdemonstrativo_financeiro.AfterLoadDFMValues;
    Plano_ContasDatasetcodigo_interno.AfterLoadDFMValues;
    Plano_ContasDatasetexcluido.AfterLoadDFMValues;
    Plano_ContasDatasetinclusao.AfterLoadDFMValues;
    Plano_ContasDatasetalteracao.AfterLoadDFMValues;
    Plano_ContasDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
